import { Transport } from "viem";

export function gasEstimator<const transport extends Transport>(originalTransport: transport): transport {
  return ((opts) => {
    const { request: originalRequest, ...rest } = originalTransport(opts);

    return {
      ...rest,
      async request(req) {
        if (req.method === "eth_estimateUserOperationGas") {
          return {
            callGasLimit: 1_000_000n,
            preVerificationGas: 100_000n,
            verificationGasLimit: 1_000_000n,
            paymasterVerificationGasLimit: 100_000n,
            paymasterPostOpGasLimit: 100_000n,
          };
        }

        return originalRequest(req);
      },
    };
  }) as transport;
}
